import { render, staticRenderFns } from "./Briefcase.vue?vue&type=template&id=9c8806b8"
import script from "./Briefcase.vue?vue&type=script&lang=js"
export * from "./Briefcase.vue?vue&type=script&lang=js"
import style0 from "./Briefcase.vue?vue&type=style&index=0&id=9c8806b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports